import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable()
export class ApiService {

    getMobileAPI() {
        return environment.API_ENDPOINT;
    }

    getMobileApiKey() {
        return environment.API_KEY;
    }

    getVerboseTracing() {
      return environment.VerboseTracing;
    }

    getCmsAPI() {
      return environment.WEBADMIN_ENDPOINT;
    }

    getCmsAPIKey() {
      return environment.WBCRM_KEY;
    }

    getPaypalClientId() {
      return environment.PAYPAL_ClIENT_ID;
    }

    getPaypalEnvironment() {
      return environment.PAYPAL_ENVIRONMENT;
    }

    getPaypalReturnURL() {
      return environment.PAYPAL_RETURN_URL;
    }
}
